import axios from "axios";
axios.defaults.withCredentials = false;
export const AuthApi = {
  login: async ({ email, password }) => {
    try {
      if (!email || !password) {
        throw new Error("Email and password are required");
      }
      const apiUrl = process.env.REACT_APP_API_URL;

      const response = await axios.post(
        `${apiUrl}/login`,
        {
          email,
          password,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "Access-Key": process.env.REACT_APP_ACCESS_KEY, // Use environment variable for access key
          },
        }
      );

      // const response = await axios.get(`${apiUrl}/login`, {
      //   params: {
      //     email,
      //     password,
      //   },
      //   headers: {
      //     "Access-Key": process.env.REACT_APP_ACCESS_KEY, // Use environment variable for access key
      //     "Content-Type": "application/json",
      //   },
      // });

      if (response.status !== 200) {
        throw new Error("Login failed with status: " + response.status);
      }
      if (response.data.error_code !== 200) {
        throw new Error("Login failed: " + response.data.message);
      }
      // console.log("Login successful:", response.data);
      if (response.data.data.id !== 2) {
        throw new Error("Login failed");
      }
      return response.data;
    } catch (error) {
      console.error("Error during login:", error);
      throw error;
    }
  },
};
